import { useState } from "react";

export type WebsiteLeadFilterState = {
    archived: boolean;
    therapyCategoryIds: string[];
};

const defaultFilters: WebsiteLeadFilterState = {
    archived: false,
    therapyCategoryIds: []
};

export const useWebsiteLeadFilters = () => {
    const [filters, setFilters] =
        useState<WebsiteLeadFilterState>(defaultFilters);

    return { filters, setFilters };
};
